import * as React from 'react'
import CtaAndTerms from './CtaAndTerms'
import NoopBlurredPlagiarismCard from './NoopBlurredPlagiarismCard'
import { UpsellContainer, V1PlagiarismText } from './styled'

interface FreemiumV1ContentProps {
  upgrade?: () => void
  plagiarismText: string
}

export const FREEMIUM_PLAGIARISM_TEXT = 'freemiumPlagiarismText'

const FreemiumPlagiarismLockContent: React.FunctionComponent<FreemiumV1ContentProps> = ({
  plagiarismText,
  upgrade,
}) => (
  <NoopBlurredPlagiarismCard>
    <UpsellContainer>
      <React.Fragment>
        <V1PlagiarismText data-test={FREEMIUM_PLAGIARISM_TEXT}>
          {plagiarismText}
        </V1PlagiarismText>
        <CtaAndTerms upgrade={upgrade} />
      </React.Fragment>
    </UpsellContainer>
  </NoopBlurredPlagiarismCard>
)

export default FreemiumPlagiarismLockContent



// WEBPACK FOOTER //
// ./src/components/PlagiarismLock/FreemiumPlagiarismLockContent.tsx